module.exports = __webpack_public_path__ + "images/aristo/ui-icons_454545_256x240.png";